<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="./">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>营销分配</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容 -->
    <div class="content">
      <el-form inline label-position="right" label-width="80px" size="small" class="query-form">
        <el-form-item label="录入月份">
          <el-date-picker
            v-model="query.time"
            type="month"
            value-format="yyyy-MM"
            @change="monthSelect"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="缴费时间" label-width="80px" style="margin-left:8px;">
          <el-date-picker
            v-model="query.daterange"
            @change="getCollect()"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>

       

        <el-form-item>
          <el-button type="primary" @click="getCollect();">查询</el-button>
        </el-form-item>
      </el-form>

      <div style="height:20px;"></div>
      <el-card class="box-card collectCard" shadow="always">
        <div class="clearfix" slot="header">
          <span>汇总详情 ({{query.time||'全部'}})</span>
        </div>
        <div class="index-card" style="height:auto;">
          <el-table :data="list" stripe style="width: 100%; ">
            <el-table-column prop="realName" label="营销"></el-table-column>
            <el-table-column prop="allCount" label="分配总数" sortable></el-table-column>
            <el-table-column prop="followCount" label="有效资源" sortable></el-table-column>
            <el-table-column prop="outCount" label="退出人数" sortable></el-table-column>
            <el-table-column prop="failCount" label="淘汰人数" sortable></el-table-column>
            <el-table-column prop="realCount" label="签约人数" sortable></el-table-column>
          </el-table>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
import "echarts/theme/macarons.js";
import url from "@/plugins/urlHelper.js";
import SelectAbroad from "@/components/SelectAbroad";
export default {
  data() {
    //初始化时间
    var now = new Date();
    var month = now.getMonth() + 1;
    if (month < 10) {
      month = "0" + month;
    }
    // this.query.time = now.getFullYear() + "-" + month;
    return {
      domain: url.getDomain(),
      query: { time: now.getFullYear() + "-" + month }, //对象
      loading: false,
      currentPage4: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      dialogVisible: false,
      submiting: false,
      daterange:[],//缴费时间
      list: [] //数据详情
    };
  },
  components: {
    SelectAbroad
  },
  methods: {
    monthSelect(e) {
      //月份选择
      this.getCollect();
    },
    //获取学校统计，地区统计
    getCollect() {
      var _this = this;
      var query = _this.query;
      if (_this.query.daterange) {
        query.payStart = _this.query.daterange[0];
        query.payEnd = _this.query.daterange[1];
      } else {
        query.payStart = "";
        query.payEnd = "";
      }
      //柱状图
      var link2 = url.getCollect("getmarket");
      $.get(link2, query, data => {
        _this.list = data;
      });
    }
  },
  created() {},
  mounted() {
    //加载列表
    this.getCollect();
  }
};
</script>

<style>
.query-form {
  margin-top: 20px;
  padding-top: 25px;
  background: #f2f2f2;
}
.el-form-item--small.el-form-item {
  margin-right: 0px;
}
.el-button--primary {
  margin-left: 10px;
}
</style>
